<div class="campanha-resultado-view">
    <div class="campanha-resultado-view-header">
        <div class="row" *ngIf="isShowAquisicoes">
            <!-- Leads -->
            <div class="form-group col-12 col-md-3">
                <label class="col-form-label">Leads Cadastrados</label>
                <div class="input-group">
                    <input type="text" class="form-control text-right" value="{{resultado?.quantidadeLeadsCadastros | decimalFormat: 1:0:0}}" disabled="disabled" readonly="readonly">
                    <div class="input-group-append">
                      <span class="input-group-text">Lead(s)</span>
                    </div>
                </div>  
                <p class="form-text text-muted">
                    Quantidade de leads cadastrados com origem através desta campanha
                </p>                       
            </div>              
            <div class="form-group col-12 col-md-3">
                <label class="col-form-label">Leads Qualificados</label>
                <div class="input-group">
                    <input type="text" class="form-control text-right" value="{{resultado?.quantidadeLeadsQualificacoes | decimalFormat: 1:0:0}}" disabled="disabled" readonly="readonly">
                    <div class="input-group-append">
                      <span class="input-group-text">Lead(s)</span>
                    </div>
                </div>  
                <p class="form-text text-muted">
                    Quantidade de leads qualificados através desta campanha
                </p>                       
            </div>

            <!-- Clientes -->
            <div class="form-group col-12 col-md-3">
                <label class="col-form-label">Clientes Cadastrados</label>
                <div class="input-group">
                    <input type="text" class="form-control text-right" value="{{resultado?.quantidadeClientesCadastros | decimalFormat: 1:0:0}}" disabled="disabled" readonly="readonly">
                    <div class="input-group-append">
                      <span class="input-group-text">Cliente(s)</span>
                    </div>
                </div>  
                <p class="form-text text-muted">
                    Quantidade de clientes cadastrados com origem através desta campanha
                </p>                       
            </div>              
            <div class="form-group col-12 col-md-3">
                <label class="col-form-label">Clientes Adquiridos</label>
                <div class="input-group">
                    <input type="text" class="form-control text-right" value="{{resultado?.quantidadeClientesAquisicoes | decimalFormat: 1:0:0}}" disabled="disabled" readonly="readonly">
                    <div class="input-group-append">
                      <span class="input-group-text">Cliente(s)</span>
                    </div>
                </div>  
                <p class="form-text text-muted">
                    Quantidade de clientes adquiridos através desta campanha
                </p>                       
            </div> 

        </div>
        <div class="row">
            <!-- Vendas -->
            <div class="form-group col-12 col-md-3">
                <label class="col-form-label">Total das Vendas</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">R$</span>
                    </div>
                    <input type="text" class="form-control text-right" value="{{resultado?.valorTotalPedidosVendas | decimalFormat: 1:2:2}}" disabled="disabled" readonly="readonly">
                </div>  
                <p class="form-text text-muted">
                    Valor total vendido nesta campanha
                </p>                       
            </div>                                  
        </div>
    </div>

    <div class="campanha-resultado-view-body">
        <p class="text-muted" *ngIf="isLoading">
            <i class='fas fa-spinner fa-pulse'></i> Carregando resultados
        </p>    

        <ul class="nav nav-tabs">     
            <li class="nav-item">
                <a class="nav-link" data-target="#tabResultadoLeads" data-toggle="tab" (click)="onTabLeadsClick()" *ngIf="isShowAquisicoes">Leads</a>
            </li>              
            <li class="nav-item">
                <a class="nav-link" data-target="#tabResultadoClientes" data-toggle="tab" (click)="onTabClientesClick()" *ngIf="isShowAquisicoes">Clientes</a>
            </li>   
            <li class="nav-item">
                <a class="nav-link active" data-target="#tabResultadoVendas" data-toggle="tab" (click)="onTabVendasClick()">Vendas</a>
            </li>                                                           
        </ul>            
        <div class="tab-content">               
            <!-- Leads -->
            <div class="tab-pane" id="tabResultadoLeads" *ngIf="isShowAquisicoes">
                <sgt-campanha-lead-view
                    #resultadoLeads
                    [idCampanha]="idCampanha">
                </sgt-campanha-lead-view>
            </div>        

            <!-- Clientes -->
            <div class="tab-pane" id="tabResultadoClientes" *ngIf="isShowAquisicoes">
                <sgt-campanha-cliente-view
                    #resultadoClientes
                    [idCampanha]="idCampanha"
                    [quantidadeClientesAquisicoes]="resultado?.quantidadeClientesAquisicoes">
                </sgt-campanha-cliente-view>
            </div>
            
            <!-- Vendas -->
            <div class="tab-pane tab-pane-vendas active" id="tabResultadoVendas">
                <sgt-campanha-pedido-view
                    #resultadoVendas
                    [idCampanha]="idCampanha"
                    [filter]="filter"
                    [objetivoVenda]="true"
                    [showStatusMetas]="!isStatusEmAnalise || resultado?.quantidadePedidosBonificacoesNaoLiberados > 0"
                    [showStatusNaoLiberado]="isStatusEmAnalise">
                </sgt-campanha-pedido-view>
            </div>               
        </div>        
    </div>
</div>